import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import { getStripeSessions } from 'app/ducks/stripeSessions/selectors';

import * as stripeSessionActions from 'app/ducks/stripeSessions/actions';
import ManageBilling from './components/ManageBilling';
import SelectPlan from './components/SelectPlan';


interface IBillingLayoutProps {
  appReady: boolean;
  match: any;
}

export function selector(state) {
  return {
    stripeSessions: getStripeSessions(state),
  };
}

const actionCreators = _.merge(stripeSessionActions);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  } as any),
)
export default class BillingLayout extends React.Component<IBillingLayoutProps> {
  static defaultProps: IBillingLayoutProps = {
    appReady: false,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="billing-app" match={this.props.match}>
        <Route
          exact
          path={['/billing']}
          render={(): React.ReactNode => <ManageBilling {...this.props} />}
        />
        <Route
          exact
          path={['/billing/select-plan']}
          render={(): React.ReactNode => <SelectPlan {...this.props} />}
        />
      </RenderContent>
    );
  }
}
